import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useArchiveDownload } from "../../../../hooks";
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../../i18n/namespaces";
import { ViewerControlTooltip } from "../../tooltip";
import { ViewerControlButton } from "../button";
import { ViewerControlDownloadOverlay } from "./overlay";
import '@isyc-react/design/main';
export const ViewerControlButtonDownload = props => {
  const {
    disabled,
    archive,
    mime,
    name
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  const [download, {
    loading,
    error,
    progress
  }, cancel] = useArchiveDownload(archive, name, mime);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(ViewerControlDownloadOverlay, {
    progress: progress,
    onCancel: () => cancel()
  }) : /*#__PURE__*/React.createElement(ViewerControlTooltip, {
    tooltip: t('archive.view.controls.download')
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    className: "d-flex align-items-center justify-content-center",
    disabled: disabled || loading,
    onClick: () => download()
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-download"
  }))));
};